const checkTokenExpiry = (expiry: Date) => {
  const now = new Date();
  const expiryDate = new Date(expiry);
  const isExpired = expiryDate < now;  
  return isExpired;
};

const islogined = () => {
  const tokenData = localStorage.getItem("token");
  const twoFAVerified = JSON.parse(localStorage.getItem("2FAVerified") || 'false');
  if (!tokenData || !twoFAVerified) {
    return false;
  }
  const { token, expires } = JSON.parse(tokenData);
  const isTokenExpired = checkTokenExpiry(expires);
  if (!expires || !token || isTokenExpired) {
    return false;
  }
  return !!token;
};

const getAuthToken = () => {
  const tokenData = localStorage.getItem("token");
  if (!tokenData) {
    return false;
  }
  const { token } = JSON.parse(tokenData);  
  return token;
};

const logoutHandler=()=>{
  localStorage.removeItem("token");
  localStorage.removeItem("2FAVerified");
}

export { islogined, getAuthToken, checkTokenExpiry, logoutHandler };
